export default __webpack_public_path__ + "static/media/croptop-large-front-toosmall.4650bb42.jpg";